export default `vec3 tetrahedralFold(vec3 z) {
    
    

    
    if (z.x + z.y < 0.0) z.xy = -z.yx;

    
    if (z.x + z.z < 0.0) z.xz = -z.zx;

    
    if (z.y + z.z < 0.0) z.zy = -z.yz;

    return z;
}

vec3 tetrahedralFoldAccurate(vec3 z) {
    
    vec3 n1 = normalize(vec3( 1.0,  1.0,  1.0));
    vec3 n2 = normalize(vec3(-1.0, -1.0,  1.0));
    vec3 n3 = normalize(vec3( 1.0, -1.0, -1.0));
    vec3 n4 = normalize(vec3(-1.0,  1.0, -1.0));

    
    z -= 2.0 * min(0.0, dot(z, n1)) * n1;
    z -= 2.0 * min(0.0, dot(z, n2)) * n2;
    z -= 2.0 * min(0.0, dot(z, n3)) * n3;
    z -= 2.0 * min(0.0, dot(z, n4)) * n4;

    return z;
}

float sdSierpinskiWithBase(vec3 p, int iterations, float scale, float baseSize) {
    vec3 z = p;
    float s = 1.0;
    for (int i = 0; i < 20; i++) {
        if (i >= iterations) break;
        z = tetrahedralFold(z);
        z = z * scale - vec3(scale - 1.0);
        s *= scale;
    }
    return sdTetrahedron(z, baseSize) / max(1.0, s);
}

float sdSierpinski(vec3 p, int iterations, float scale) {
    return sdSierpinskiWithBase(p, iterations, scale, 0.6);
}

float sdSierpinskiSimple(vec3 p, int iterations, float scale) {
    vec3 z = p;
    float dist = 0.0;

    for (int i = 0; i < 20; i++) {
        if (i >= iterations) break;

        
        z = tetrahedralFold(z);

        
        z *= scale;
        z -= vec3(scale - 1.0);
    }

    
    
    return (length(z) - 2.0) / pow(scale, float(iterations));
}

float sdSierpinskiCustom(vec3 p, int iterations, float scale, vec3 offset) {
    vec3 z = p;
    float r = length(z);
    float dr = 1.0;

    for (int i = 0; i < 20; i++) {
        if (i >= iterations) break;

        z = tetrahedralFold(z);
        z = z * scale - offset * (scale - 1.0);
        dr = dr * scale;
        r = length(z);
    }

    return (r - 2.0) / dr * 0.25;
}

struct SierpinskiResult {
    float dist;
    float orbitTrap;
};

SierpinskiResult sdSierpinskiColored(vec3 p, int iterations, float scale) {
    vec3 z = p;
    float r = length(z);
    float dr = 1.0;
    float minDist = 1000.0; 

    for (int i = 0; i < 20; i++) {
        if (i >= iterations) break;

        z = tetrahedralFold(z);
        z = z * scale - vec3(scale - 1.0);
        dr = dr * scale;
        r = length(z);

        
        minDist = min(minDist, r);
    }

    SierpinskiResult result;
    result.dist = (r - 2.0) / dr * 0.25;
    result.orbitTrap = minDist;

    return result;
}`